import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Icon from "./Icon";
import Button from "./Button";
import styles from "./NonIdealState.module.css";

export default class NonIdealState extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, visual, spin, action } = this.props;

    return (
      <div className={styles.container}>
        {typeof visual === "string" ? (
          <Icon icon={visual} spin={spin?.toString()} />
        ) : (
          visual
        )}
        <h2>{title}</h2>

        {action && <Button onClick={this.props.onAction}>{action}</Button>}
      </div>
    );
  }
}

NonIdealState.propTypes = {
  title: PropTypes.string.isRequired,
  visual: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  spin: PropTypes.bool,
  action: PropTypes.string,
};
